module.exports = __webpack_public_path__ + "db860d0a0f915ad1356e9e6806c4463f.png";